import React from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { LoadingType, setLoadingState, setSignInStep, SignInStep } from 'actions';
import AccountForm from 'components/Form/AccountForm';
import { AccountFormData } from 'components/Form/AccountForm/AccountForm';
import FormHeader from 'components/FormHeader';
import Loader from 'components/Loader';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useAppNavigate from 'hooks/useAppNavigate';
import { useAppSelector } from 'hooks/useAppSelector';
import { AppRoutes } from 'routes/routes.enums';
import * as notificationManager from 'notifications';
import { FailureNotificationType } from 'notifications';
import { authApi } from 'api/auth/AuthApi';

import styles from './EnterNewPassword.module.scss';

const EnterNewPassword = () => {
  const dispatch = useAppDispatch();
  const navigator = useAppNavigate();
  const { token } = useParams();

  const loading = useAppSelector((state) => state.loading[LoadingType.GetData]);

  const handleSubmit = async (data: AccountFormData) => {
    try {
      if (data.password && token) {
        dispatch(setLoadingState({ type: LoadingType.GetData, loading: true }));
        await authApi.resetPassword(data.password as string, token);
        dispatch(setLoadingState({ type: LoadingType.GetData, loading: false }));
        dispatch(setSignInStep(SignInStep.SignIn));
        navigator(AppRoutes.Login);
      }
    } catch (error: any) {
      notificationManager.notifyFailure(FailureNotificationType.UnknownError);
    } finally {
      dispatch(setLoadingState({ type: LoadingType.GetData, loading: false }));
    }
  };

  const formMethods = useForm({
    defaultValues: {
      password: '',
    },
  });

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <FormHeader
            title="Enter Your New Password to Sign In"
            classNameWrapper={styles.customFormHeader}
            classNameTitle={styles.customFormTitle}
          />
          <FormProvider {...formMethods}>
            <AccountForm
              showPasswordField
              showPasswordCaption
              buttonLabel="Submit"
              buttonRowClassname={styles.buttonRow}
              onSubmit={handleSubmit}
            />
          </FormProvider>
        </div>
      )}
    </>
  );
};

export default EnterNewPassword;
